import { Button, IconButton, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import cancel from "../../../src/images/Vector.svg"; // Ensure the image path is correct
import "./ConfirmModal.css"; // Ensure this file contains relevant styling

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
}));
  
export default function UserSelectorModal(props) {
  const confirmModal = useSelector((state) => state.confirmModal);
  const dispatch = useDispatch();
  const classes = useStyles();

  const [lazyLoading, setLazyLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(true); // For controlling dialog visibility

  const handleConfirm = () => {
    props.onRefreshConfirm("yes");
  };

  const handleClose = () => {
    props.onRefreshCancel("no");
  };

  return (
    <>
      <div >
        <div>
          <Dialog
            open={showDialog}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
            {Array.isArray(props.onMessage) ? props.onMessage[0] : ""}
              </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
              {Array.isArray(props.onMessage) && props.onMessage[1]
                ? props.onMessage[1]
                : ""}              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleConfirm} color="primary">
               YES
              </Button>
              <Button onClick={handleClose} color="secondary">
                NO
              </Button>
            </DialogActions>
          </Dialog>     
        </div>
      </div>
    </>
  );
}
